/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerRoleModel } from '../../models/practitioner-role-model';

export interface AdminPersonIdGetRolesGet$Params {
  personId: string;
}

export function adminPersonIdGetRolesGet(http: HttpClient, rootUrl: string, params: AdminPersonIdGetRolesGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>> {
  const rb = new RequestBuilder(rootUrl, adminPersonIdGetRolesGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>;
    })
  );
}

adminPersonIdGetRolesGet.PATH = '/Admin/{personId}/GetRoles';
